export const ALL_TAB_PERMISSIONS: { value: string; label: string }[] = [
  { value: "tab:screen", label: "Screen" },
  { value: "tab:positions", label: "Positions" },
  { value: "tab:matrices", label: "Matrix" },
  { value: "tab:candidates", label: "Candidates" },
  { value: "tab:archived", label: "Archived" },
  { value: "tab:calendar", label: "Calendar" },
  { value: "tab:users", label: "Users" },
  { value: "tab:organizations", label: "Organizations" },
  { value: "tab:roles", label: "Roles" },
];

export const ALL_RESOURCE_PERMISSIONS: { value: string; label: string }[] = [
  { value: "screen", label: "Screen Resumes" },
  { value: "positions:read", label: "View Positions" },
  { value: "positions:write", label: "Manage Positions" },
  { value: "matrices:read", label: "View Matrices" },
  { value: "matrices:write", label: "Manage Matrices" },
  { value: "candidates:read", label: "View Candidates" },
  { value: "candidates:write", label: "Manage Candidates" },
  { value: "interviews:read", label: "View Interviews" },
  { value: "interviews:write", label: "Schedule Interviews" },
  { value: "users:read", label: "View Users" },
  { value: "users:write", label: "Manage Users" },
  { value: "organizations:manage", label: "Manage Organizations" },
  { value: "roles:manage", label: "Manage Roles" },
  // Profile tab permissions
  { value: "profile:personal:read",    label: "View Personal Tab" },
  { value: "profile:personal:write",   label: "Edit Personal Tab" },
  { value: "profile:social:read",      label: "View Social Tab" },
  { value: "profile:social:write",     label: "Edit Social Tab" },
  { value: "profile:education:read",   label: "View Education Tab" },
  { value: "profile:education:write",  label: "Edit Education Tab" },
  { value: "profile:resume:read",      label: "View Resume Tab" },
  { value: "profile:resume:write",     label: "Edit Resume Tab" },
  { value: "profile:salary:read",      label: "View Salary Tab" },
  { value: "profile:salary:write",     label: "Edit Salary Tab" },
  { value: "profile:documents:read",   label: "View Documents Tab" },
  { value: "profile:documents:write",  label: "Edit Documents Tab" },
  { value: "profile:contacts:read",    label: "View Contacts Tab" },
  { value: "profile:contacts:write",   label: "Edit Contacts Tab" },
  { value: "profile:interviews:read",  label: "View Interviews Tab" },
  { value: "profile:interviews:write", label: "Edit Interviews Tab" },
  { value: "profile:notes:read",       label: "View Notes Tab" },
  { value: "profile:notes:write",      label: "Edit Notes Tab" },
  { value: "profile:activity:read",    label: "View Activity Tab" },
];

export const TAB_LABELS: Record<string, string> = Object.fromEntries(
  ALL_TAB_PERMISSIONS.map((p) => [p.value, p.label])
);

export const RESOURCE_LABELS: Record<string, string> = Object.fromEntries(
  ALL_RESOURCE_PERMISSIONS.map((p) => [p.value, p.label])
);
